var SortedArray = (function () {
  var SortedArray = defclass({
    constructor: function (array, compare) {
      this.array = array;
      this.compare = compare || compareDefault;
      this.array.sort(this.compare);
    },
    insert: function (element) {
      var array = this.array;
      var compare = this.compare;
      var index = array.length;

      array.push(element);

      while (index > 0) {
        var i = index;
        var j = --index;

        if (compare(array[i], array[j]) < 0) {
          var temp = array[i];
          array[i] = array[j];
          array[j] = temp;
        }
      }

      return this;
    },
    search: function (element) {
      var array = this.array;
      var compare = this.compare;
      var high = array.length;
      var low = 0;

      while (high > low) {
        var index = ((high + low) / 2) >>> 0;
        var ordering = compare(array[index], element);

        if (ordering < 0) low = index + 1;
        else if (ordering > 0) high = index;
        else return index;
      }

      return -1;
    },
    remove: function (element) {
      var index = this.search(element);
      if (index >= 0) this.array.splice(index, 1);
      return this;
    },
  });

  SortedArray.comparing = function (property, array) {
    return new SortedArray(array, function (a, b) {
      return compareDefault(property(a), property(b));
    });
  };

  return SortedArray;

  function defclass(prototype) {
    var constructor = prototype.constructor;
    constructor.prototype = prototype;
    return constructor;
  }

  function compareDefault(a, b) {
    if (a === b) return 0;
    return a < b ? -1 : 1;
  }
})();

// if (typeof module === 'object') module.exports = SortedArray
// if (typeof define === 'function' && define.amd) { define(function () { return SortedArray }) }

export default SortedArray;
